
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqA60ydYsESMOG0Dem5xOw75_vfZUY5Sqj247Z_k5UO_45wMeta } from "/codebuild/output/src3080681059/src/src/pages/faq.vue?macro=true";
import { default as menu2_45NoF6hihCe4rE68SPh2TiDqmvUw0_8_p80udAC8DFMMeta } from "/codebuild/output/src3080681059/src/src/pages/menu.vue?macro=true";
import { default as indexBnf5t3R7AnSIOnq6IZgqzQNbB9vFD2Vm48Hmi28P5OAMeta } from "/codebuild/output/src3080681059/src/src/pages/index.vue?macro=true";
import { default as contact06LoiVNeChesFAR1YFFuOjvNmOUmLf_8k9yhVlc_kDQMeta } from "/codebuild/output/src3080681059/src/src/pages/contact.vue?macro=true";
import { default as tutorialnRPNEB6FS_Ne7lcYMPdXx8hYrXe51QMfpzlmNf8U8gEMeta } from "/codebuild/output/src3080681059/src/src/pages/tutorial.vue?macro=true";
import { default as agreementeSCxLytAenOFPhtQc_X9hhYMMR5u6496dQlYfqSJWnoMeta } from "/codebuild/output/src3080681059/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass1ttD_45W89mLe35FXovpVdTa6Yeo4_S9BsN2SX2oBaQlUMeta } from "/codebuild/output/src3080681059/src/src/pages/about-pass.vue?macro=true";
import { default as indexkDt21DJZzngjOuAob6EbIbygwOmPYSFAOja_45QKTbMfEMeta } from "/codebuild/output/src3080681059/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93kGrsfz4bKguT6aR74AcDgJH55Twxpn0p3HMXMVvyU6MMeta } from "/codebuild/output/src3080681059/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance61Yjn4U6Xu_dIuDShd0OMcTEn3irXAEwg_450WjgYhXoAMeta } from "/codebuild/output/src3080681059/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93XG2w1iBqFRlw8X8Y1R43OEzqIbR6_Gs52fIi5ayYLmAMeta } from "/codebuild/output/src3080681059/src/src/pages/notice/[id].vue?macro=true";
import { default as indexYmwF3fHtDe6sZAW0MEUJCWrqP8GReVVt_45dgrKcKAhj0Meta } from "/codebuild/output/src3080681059/src/src/pages/coupon/index.vue?macro=true";
import { default as indexElpJwNLFK_45XfZkqK13E41Ot19xGh3WSP2p_45_45kS3MGqcMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/index.vue?macro=true";
import { default as index541jRpSQdYYpG9tB_nosFIbpUec5hrlQI1ofCS7AJjQMeta } from "/codebuild/output/src3080681059/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93ONaY7pwgTcqj7xgOjrF5wKdadZF85Cgu7JaMy0bd3pQMeta } from "/codebuild/output/src3080681059/src/src/pages/parking/[id].vue?macro=true";
import { default as indexeiyWeoMaThIZ53IcdyhNieFnM6Sf0EfKC9Sp7AZsQVUMeta } from "/codebuild/output/src3080681059/src/src/pages/history/index.vue?macro=true";
import { default as indexfLbqmN_6pVkBFhujZeQu6OPHQ2f4_WwD0YP2juVN0JQMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/index.vue?macro=true";
import { default as indexSPj_45RkYNUQOXu_45pbN6D4CPyXcNjJdoy4AjgF1vnhumkMeta } from "/codebuild/output/src3080681059/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexQgQOGYtgKp6bQKGGmaPzVM9ykaV8j9oPEGY_45kLLof_wMeta } from "/codebuild/output/src3080681059/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi7fxHaESjkYVnMTuKOyJz17jWvzAKx2K3fMydIcCQ9hsMeta } from "/codebuild/output/src3080681059/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editEKJCAzohW8zZWb5sb_LQnK3ShGYv9Yp5Ne2BSMjZaiAMeta } from "/codebuild/output/src3080681059/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementBB_45qifluav0cG4xZH02_QgQe27zuP_458Rq4NksQPk0OgMeta } from "/codebuild/output/src3080681059/src/src/pages/pass-agreement.vue?macro=true";
import { default as index_qn8xldrWsZQq7J1KqMeVBxJDcQdviBrDN4Q78XBvTMMeta } from "/codebuild/output/src3080681059/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dKGc6gOekT9yNNC8ksMgsxeMIMQZ1iLhMbiuKQXYrTu4Meta } from "/codebuild/output/src3080681059/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmbXe_E1I2NyPlzfcsKS38DImDnLXbBPB5qwpQGjucLTYMeta } from "/codebuild/output/src3080681059/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexIl5uWGF0KRqe13BnVurKpS0Ygox2umWa9DdU_tu7vgIMeta } from "/codebuild/output/src3080681059/src/src/pages/card/create/index.vue?macro=true";
import { default as indexFHG_qpFKY6_cs52YktOMu2g7uW84foi07H4SEgxgMekMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmfRhB_45Zw2tN8d8TOSsiYoclPOyuThckYdZKRSRBE_lyYMeta } from "/codebuild/output/src3080681059/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmkUTnThxlPuB2gJhu2my5rLLs0uYNfY2y2cFeAhg0NQ0Meta } from "/codebuild/output/src3080681059/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeZpdrNcUkSL2oFR76JU_h8abXClg4qQumKy_45UnMu1UnUMeta } from "/codebuild/output/src3080681059/src/src/pages/membership/complete.vue?macro=true";
import { default as registerSXJ1huE9ces77C_hC7FvoBEYfBDYULEogjvr6JiC_S0Meta } from "/codebuild/output/src3080681059/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_9347iI06yAgc_hpQtWt4ihPiVzY2HqRNQsVHZ06FnBlisMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmbWXslHBjjU0jxMeUuzqFZ63DhZRCv_45vYSCnfFP96deQMeta } from "/codebuild/output/src3080681059/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93uBR5pGF0C5pKG_45SMJzfCuBGy_I8Aijw1fExm8I8r6RAMeta } from "/codebuild/output/src3080681059/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index9dRA9_7T_45nLCimrQlXMMY49R4RzbKKoR2ZPc8E_452pOkMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeZGcXuQPgZuUBM0LhQ0rLbCS4JFbrqlMs3cz9r9QVg9EMeta } from "/codebuild/output/src3080681059/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codegdMRKGAmCjrZjjv_45jx6WEI_AaOObyfTil3_YcTaABjoMeta } from "/codebuild/output/src3080681059/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeWk326hJl3XsqgCKyIgY_FRWo311rJbmsoElgxMYjmmkMeta } from "/codebuild/output/src3080681059/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerwCHeR99kilLlzDXC_aeR8svGDqELZtVlUWtPNKbe_453AMeta } from "/codebuild/output/src3080681059/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeiZZGLwjcDNyHDeIvDGImq1dKmMy53WSPjgGi8EuL9AUMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexMBzFtbFI9dMjLSvjaxJTRVrGdtgpramsvoWW8_9eAFIMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmZSpGtK_454f5UEGhVTjuEH_45V3Eg5BAcxO5krfWp4ncMaQMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completegCJjDt_45ZtOF7mWbq2U4XHj6NlQc_45fDfFrZTW4LqMgzwMeta } from "/codebuild/output/src3080681059/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexaOaZY6Whfkcim2YvdyVJuuc5jjVBgTm9xCJhwcLGidAMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93j_FOJ4NnK8LI6pnVXXfhI6NbsJLj6XmuPaY9g2mLZRUMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeXqHsc5OrlaFl_4579vtX1MrMv_IDp_xj10YzkzRMZX4PcMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliastoy0ioez76luOcLKHuhWMQp42sbiVJQRP48hLRyx1eUMeta } from "/codebuild/output/src3080681059/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleGojQWstuYR3AxJKoj1KzDBw_452YIzyXbGrAjRudEmKAUMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailhFv_45XRosmMeoA1vIMrspJN5LbmC08DS2Usmp5JNbtAMMeta } from "/codebuild/output/src3080681059/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmPcQXn3Q3ppTG05cpRM6AsWFhx34vYgYubwdwecCv7eIMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentGhS6H6mFY14tCsKWn9hCkOnaTc_45UP2DsIMNFqugMvSUMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmdDCmrlUDzcZUEOCRctMKkuQZHLqjNB5449UVOdeIZckMeta } from "/codebuild/output/src3080681059/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate6Zjw_45c5WdeCaewvdcfHNZQyz3GrYghUUFOFynShnWLEMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeSdq43O337CszxqKj0dtwK4voI8nFoBPBPS4OOhkbdxYMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codevgD6KgKPNYwij_45RhOP1LREMVGYuotGH1B9KM82J0Lz0Meta } from "/codebuild/output/src3080681059/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordXEkwDZoVFdD3LfpBh0gI3QFog6wfxIOemflnvqQq1PIMeta } from "/codebuild/output/src3080681059/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasGDNOKrN_G6CWuMxNJgeuMKYc_45MbC4F6tW6mULFhFviUMeta } from "/codebuild/output/src3080681059/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register_45U6pEWn3souFYLBp7QRr1gofW8O_45Ot8XkNoDDIhNeTIMeta } from "/codebuild/output/src3080681059/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codesQv3Na1y1Ny8AcwK4yBQ3Wc__28snpPmgDRBilODee8Meta } from "/codebuild/output/src3080681059/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexnYWGroJSbEelRSagr6WKk2VcV1nrSgVVYtafrvNdsuEMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexAvoar3Zc6YFvYAETPE638Oolx8z9KJmhjMT2njr1UIwMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexTL9MpnmrlDrYgXvIZwygdKUELRIESfYV1akIRPSLBosMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index0_rUKKO4_FzwnDwbK3mzkPIUbFQUNEAMbvY1_457_45Cp_45UMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateU4RuLesnPDAXp_hKE6cw17wy_TLlzZQOBpUUJ6VRIe8Meta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete_45J4mzJB03VMJgH5qlVMj2D5ClXoZ4TBsFDnYb7mwq44Meta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmmACmiJtz0Fl1EYGpdRWSGkuxV32SwlCaev8WN1cOaT0Meta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexXLy5CytUO4RumOoCdjls9FIOrKPHdM4z5Z6wZkuWw6IMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeDfAY0ZDJUhJ_S5xqZwM0VNek57dpiBRABDFCoUD5IQsMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatek6t68FcgHWFH10hT3JmaL7uOTo1icsJRywwWO7Otru8Meta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexbjkiDDz1DmDRHsL7QH9soAX04v1XE_CrL9e8SgFFyj4Meta } from "/codebuild/output/src3080681059/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index2LFT1cqZUzwPz8rk9jw8lwOJTL5E65fZummHJk6M6o8Meta } from "/codebuild/output/src3080681059/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete9b2sYj2Wr_XwRmZd3ZNURS8BT8Fsscjh9dfDdaBnPMUMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index5V1Qi6U_G0gPDNbCh2E3u5jw9_45bp_rMFyOWosADzeIoMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeNq_45KfGztYQoCx1gHo6RYg2B47Fun7ZUoC2teP3flWLoMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexu3tT_45heXdoK1QzQkm7H4tyHnZPVJ8gee7NWgBMf35IUMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexE6qQRISLNiSC6tC0FjzzFCAwW4ro6bF_45jk5l1ISb8xQMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexPyHd6hvPePMd36uCWcy8hGNLsQwRG31rehZJWCKCj2QMeta } from "/codebuild/output/src3080681059/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateOkz6AE4ro_45N7jK8Dk3mMTYXyiWMby101PnOpBQyR5qkMeta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmVcUhXb_9Uef5SfiLVAcLAiNTp9lV5GHLnFN2a_wSrT0Meta } from "/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu2_45NoF6hihCe4rE68SPh2TiDqmvUw0_8_p80udAC8DFMMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexBnf5t3R7AnSIOnq6IZgqzQNbB9vFD2Vm48Hmi28P5OAMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3080681059/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexYmwF3fHtDe6sZAW0MEUJCWrqP8GReVVt_45dgrKcKAhj0Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3080681059/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexeiyWeoMaThIZ53IcdyhNieFnM6Sf0EfKC9Sp7AZsQVUMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3080681059/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexSPj_45RkYNUQOXu_45pbN6D4CPyXcNjJdoy4AjgF1vnhumkMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexQgQOGYtgKp6bQKGGmaPzVM9ykaV8j9oPEGY_45kLLof_wMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexIl5uWGF0KRqe13BnVurKpS0Ygox2umWa9DdU_tu7vgIMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmfRhB_45Zw2tN8d8TOSsiYoclPOyuThckYdZKRSRBE_lyYMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmkUTnThxlPuB2gJhu2my5rLLs0uYNfY2y2cFeAhg0NQ0Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3080681059/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeZpdrNcUkSL2oFR76JU_h8abXClg4qQumKy_45UnMu1UnUMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerSXJ1huE9ces77C_hC7FvoBEYfBDYULEogjvr6JiC_S0Meta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmbWXslHBjjU0jxMeUuzqFZ63DhZRCv_45vYSCnfFP96deQMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeZGcXuQPgZuUBM0LhQ0rLbCS4JFbrqlMs3cz9r9QVg9EMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codegdMRKGAmCjrZjjv_45jx6WEI_AaOObyfTil3_YcTaABjoMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeWk326hJl3XsqgCKyIgY_FRWo311rJbmsoElgxMYjmmkMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerwCHeR99kilLlzDXC_aeR8svGDqELZtVlUWtPNKbe_453AMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmZSpGtK_454f5UEGhVTjuEH_45V3Eg5BAcxO5krfWp4ncMaQMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completegCJjDt_45ZtOF7mWbq2U4XHj6NlQc_45fDfFrZTW4LqMgzwMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexaOaZY6Whfkcim2YvdyVJuuc5jjVBgTm9xCJhwcLGidAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeXqHsc5OrlaFl_4579vtX1MrMv_IDp_xj10YzkzRMZX4PcMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleGojQWstuYR3AxJKoj1KzDBw_452YIzyXbGrAjRudEmKAUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailhFv_45XRosmMeoA1vIMrspJN5LbmC08DS2Usmp5JNbtAMMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmPcQXn3Q3ppTG05cpRM6AsWFhx34vYgYubwdwecCv7eIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentGhS6H6mFY14tCsKWn9hCkOnaTc_45UP2DsIMNFqugMvSUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmdDCmrlUDzcZUEOCRctMKkuQZHLqjNB5449UVOdeIZckMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeSdq43O337CszxqKj0dtwK4voI8nFoBPBPS4OOhkbdxYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codevgD6KgKPNYwij_45RhOP1LREMVGYuotGH1B9KM82J0Lz0Meta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordXEkwDZoVFdD3LfpBh0gI3QFog6wfxIOemflnvqQq1PIMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register_45U6pEWn3souFYLBp7QRr1gofW8O_45Ot8XkNoDDIhNeTIMeta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codesQv3Na1y1Ny8AcwK4yBQ3Wc__28snpPmgDRBilODee8Meta || {},
    component: () => import("/codebuild/output/src3080681059/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3080681059/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]